export const CHANGE_COLOR = 'CHANGE_COLOR';
export const CHANGE_TEMP_COLOR = 'CHANGE_TEMP_COLOR';
export const CHANGE_THICKNESS = 'CHANGE_THICKNESS';
export const CHANGE_TRANSPARENCY = 'CHANGE_TRANSPARENCY'